import { Card, Skeleton, Space } from "antd";

const PageSkeleton = () => {
  const columns = Array.from({ length: 6 }, (_, index) => ({
    title: "",
    dataIndex: `col${index}`,
    key: `col${index}`,
  }));

  const mockData = Array.from({ length: 5 }, (_, index) => ({
    key: index,
    ...columns.reduce((acc, col) => ({ ...acc, [col.dataIndex]: "" }), {}),
  }));

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <div style={{ marginBottom: "24px" }}>
        <Skeleton.Input
          active
          size="large"
          style={{
            width: "200px",
            height: "32px",
            marginBottom: "8px",
            backgroundColor: "#d9d9d9",
          }}
        />
        <br />
        <Skeleton.Input
          active
          size="default"
          style={{
            width: "400px",
            height: "20px",
            backgroundColor: "#d9d9d9",
          }}
        />
      </div>

      <Card
        style={{
          border: "2px solid #e6f7ff",
          borderRadius: "8px",
          backgroundColor: "#fafafa",
        }}
        bodyStyle={{ padding: "24px" }}
      >
        <div style={{ marginBottom: "24px" }}>
          <Space wrap>
            <Skeleton.Button
              active
              size="default"
              style={{ width: "120px", height: "32px" }}
            />
          </Space>
        </div>

        <div
          style={{
            backgroundColor: "white",
            borderRadius: "6px",
            border: "1px solid #f0f0f0",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              padding: "12px 16px",
              backgroundColor: "#fafafa",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            {columns.map((_, index) => (
              <div key={index} style={{ flex: 1, marginRight: "8px" }}>
                <Skeleton.Input
                  active
                  size="small"
                  style={{
                    width: "100%",
                    height: "16px",
                    backgroundColor: "#e8e8e8",
                  }}
                />
              </div>
            ))}
          </div>

          {mockData.map((_, rowIndex) => (
            <div
              key={rowIndex}
              style={{
                display: "flex",
                padding: "12px 16px",
                borderBottom:
                  rowIndex < mockData.length - 1 ? "1px solid #f0f0f0" : "none",
              }}
            >
              {columns.map((_, colIndex) => (
                <div key={colIndex} style={{ flex: 1, marginRight: "8px" }}>
                  <Skeleton.Input
                    active
                    size="small"
                    style={{
                      width: "100%",
                      height: "20px",
                      backgroundColor: "#f0f0f0",
                    }}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "16px",
            padding: "12px 0",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Skeleton.Input
              active
              size="small"
              style={{ width: "60px", height: "20px" }}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Skeleton.Button
              active
              size="small"
              style={{ width: "24px", height: "24px" }}
            />
            <Skeleton.Button
              active
              size="small"
              style={{ width: "24px", height: "24px" }}
            />
            <Skeleton.Button
              active
              size="small"
              style={{ width: "24px", height: "24px" }}
            />
            <Skeleton.Input
              active
              size="small"
              style={{ width: "80px", height: "24px" }}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PageSkeleton;
